<script setup>
import { defineProps } from "vue"
import { Gems } from "@/gems"
import RatingScale from "../RatingScale.vue"
import { useValidationListView } from '@/composables/useValidationListView'
import BaseSelect from "../BaseSelect.vue";

const props = defineProps({
  validateData: {
    type: Object,
    default: Object
  },

  validationList: {
    type: Object,
    default: Object
  },
  
  ratingSkillsModal: {
    type: Object,
    default: Object
  },

  ratingData: {
    type: Object,
    default: Object
  },

  isOtherValidatorsList: {
    type: Boolean,
    default: false
  }
})

const { ratingType } = useValidationListView({
  validateData: props.validateData,
  ratingSkillsModal: props.ratingSkillsModal,
})



</script>

<template>
  <div>
    <div class="list-item row fw-bold p-1 m-0">
      <span class="col-4 p-0" :class="{'col-4': props.validateData.isLowerThanMobile.value}">Descrição</span>
      <span class="col-6 p-0" :class="{'col-6': props.validateData.isLowerThanMobile.value}">Classificação</span>
      <span></span>
    </div>

    <div class="list-item" :class="{'bg-alt-line': i % 2 == 0, 'div-to-validate': elem.validation_date == null && ratingType == 3}"
      v-for="(elem, i) in props.validateData.displayedRequests.value" :key="i">
      <div class="row align-items-center p-1 m-0">

        <span class="col-5 p-0 line-clamp line-clamp-1" :class="{'col-6': props.validateData.isLowerThanMobile.value}" @mouseenter="Gems.TooltipIfNeeded($event.target)">
          <i v-if="!elem.is_op_skill" class="fa-solid fa-copyright me-1" @mouseover="Gems.Tooltip($event.target, 'Conhecimento', 'tooltip')"></i>
          <span @mouseenter="Gems.Tooltip($event.target, elem.sitemap, 'tooltip tooltip-left')">
            {{ elem.designation }}
          </span>
        </span>
      
        <span class="col-5 p-0 radios">
          <RatingScale :rating-data="props.ratingData" :element="elem" :mobile-view="true" :validate-skills="true"/>
        </span>

        <div class="col-2 p-0 ps-1 d-flex">
          <div class="d-flex justify-content-center flex-grow-1">
            <i class="align-content-center far fa-eye" :class="{'eye-notification': elem.has_files_not_viewed }" 
              @click="props.ratingSkillsModal.OpenModalDocs(elem)" @mouseenter="Gems.Tooltip($event.target, 'Detalhes', 'tooltip')"></i>
            <i class="align-content-center fas fa-envelope" v-if="elem.has_unread_messages_only_validators || elem.has_unread_messages" 
              @mouseenter="Gems.Tooltip($event.target, 'Tens novas mensagens', 'tooltip')"></i>
          </div>
          <i class="bi bi-chevron-down col-auto p-0 ps-1 align-content-center text-end" :class="{'bi-chevron-up': elem.showDetail}" @click="elem.showDetail = !elem.showDetail"></i>
        </div>
      </div>
      
      <div class="row element-detail p-1 m-0 small" v-show="elem.showDetail">
        <div class="col-4 p-0">
          <div class="text-uppercase">{{ props.validateData.validationToTransfer.value ? 'Validador atual' : 'Validação' }}</div>
          <div class="line-clamp line-clamp-1" @mouseenter="Gems.TooltipIfNeeded($event.target)">
            <base-select class="ddl-alt-padding" v-model="elem.history_id" v-if="elem.validators_to_transfer?.length > 1">
              <option value="">Escolha um validador...</option>
              <option v-for="(validator, vi) in elem.validators_to_transfer || []" :value="validator.history_id" :key="vi">
                {{ validator.validator_name }}
              </option>
            </base-select>

            <div v-else>
              {{ elem.validator_name }}
            </div>
          </div>
        </div>

        <div class="col-4 p-0">
          <div class="text-uppercase">{{ props.validateData.validationToTransfer.value ? 'Validador novo' : 'Decisão' }}</div>
          <base-select class="ddl-alt-padding" v-if="props.validateData.validationToTransfer.value" v-model="elem.newValidatorId">
            <option value="">Escolha um validador...</option>
            <option v-for="(validator, vi) in elem.available_validators || []" :value="validator.validator_id" :key="vi">
              {{ validator.validator_name }}
            </option>
          </base-select>
        </div>

        <div class="text-end col-2 p-0" v-if="!props.validateData.validationToTransfer.value">
          <div class="text-uppercase">Data</div>
          <div>{{ formatDate(elem.validation_date) }}</div>
        </div>

        <div class="text-end col-4 p-0 align-self-end" v-if="props.validateData.validationToTransfer.value">
          <button class="ddl-alt-padding w-50" v-if="props.validateData.canChangeValidator(elem)" @click="props.validateData.ChangeValidator(elem)">TRANSFERIR</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.row {
  padding: 5px;
}

button {
  padding: var(--default-app-sm-padding) !important;
}

.input-small-padding {
  padding: 7px 10px !important;
}

.element-detail {
  color: var(--default-font-color) !important;
}

.card {
  background-color: #f8f9fa; /* light gray background */
}

.card .text-uppercase {
  font-size: 0.75rem;
  letter-spacing: 0.05em;
}

.div-admin-filter,
.div-admin-filter-input {
  display: flex;
  gap: 20px;
}

.div-admin-sort {
  display: flex; 
  gap: 5px;
  align-items: center; 
}

.div-admin-filter {
  font-size: .85em;
  margin-bottom: -5px;
}

.div-radios div {
  gap: 5px; 
}

.radios {
  display: flex;
  font-size: 1.2em;
  justify-content: center;
}

.div-user-sitemap {
  display: flex;
  gap: 5px;
  padding: 10px 0px;
}

.fa-envelope { 
  position: relative;
  left: 0px;
  top: -9px;
  font-size: 0.7em !important;
  width: 0px;
}

/* .ddl-alt-padding {
  padding: 3px !important;
} */

.list-item {
  border: 2px solid transparent;
}

.div-history-frame {
  border: 2px solid;
  margin-bottom: 2px;
}

.icon-size {
  font-size: unset !important;
  position: unset;
  width: auto;
}

@media screen and (max-width: 700px) {
  .list-item {
    font-size: .85em;
  }
}

@media screen and (max-width: 400px) {
  .radios {
    display: grid;
    grid-template-columns: 30px 30px 30px;
    row-gap: 3px;
  }

  .radios input {
    transform: scale(1) !important;
    margin-top: 0px;
  }

  .radios :deep(> .div-rating-frame:nth-child(3)) {
    border-top-right-radius: 25px !important;
    border-bottom-right-radius: 25px !important;
    overflow: hidden !important;
  }

  .radios :deep(> .div-rating-frame:nth-child(4)) {
    border-top-left-radius: 25px !important;
    border-bottom-left-radius: 25px !important;
    overflow: hidden !important;
  }
}
</style>